import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import BookingCalendar from "@/components/BookingCalendar";
import { useServices } from "@/lib/useServices";

export default function SchedulePage() {
  const [params] = useSearchParams();
  const [service, setService] = useState(params.get("service") || "");
  const services = useServices();

  return (
    <BookingCalendar service={service} onServiceChange={setService} services={services} />
  );
}
